import React from 'react';
export default function ConfidenceBadge({ value }) {
  if (value == null) return <span className="text-gray-400 text-xs">–</span>;
  const pct = Math.round(value * 100);
  const color = pct >= 85 ? 'text-green-700' : pct >= 65 ? 'text-yellow-700' : 'text-red-700';
  return <span className={`text-xs font-mono font-medium ${color}`}>{pct}%</span>;
}
